import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ferris/react/components/button';

export function NextButton({
    submitText,
    onClick,
    disabled
}) {
    const ButtonToUse = Button;
    return (
        <div className="ulx-location-wrapper__bottom">

            <ButtonToUse
                isFullWidth
                classes="btn-fadein"
                data-wdio="location-next-button"
                htmlButtonType="button"
                type="primary"
                onClick={onClick}
                id="locationTypeAheadNextBtn"
                disabled={disabled}
            >
                {submitText}
            </ButtonToUse>

        </div>
    );
}

NextButton.propTypes = {
    submitText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired
};

export default NextButton;
